const Aux111 = (props) => props.children;

export default Aux111;